// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* JoPath design tokens — generated from Figma "JoPath · Foundations" variables (P60), as plain CSS custom properties. Do not edit by hand; re-export instead.
   Imported before index.css: index.css's own :root re-declares --muted/--radius/--radius-sm after this file loads, so the existing OMS look is unchanged. New UI (the app shell) should read tokens from here. */

:root {
  --radius: 10px;
  --background: #f9fafb;
  --foreground: #111928;
  --card: #ffffff;
  --card-foreground: #111928;
  --popover: #ffffff;
  --popover-foreground: #111928;
  --primary: #6b1d1d;
  --primary-foreground: #ffffff;
  --primary-hover: #521313;
  --primary-pressed: #400f0f;
  --primary-subtle: #f7ecec;
  --secondary: #f3f4f6;
  --secondary-foreground: #111928;
  --muted: #f3f4f6;
  --muted-foreground: #4b5563;
  --accent: #f3f4f6;
  --accent-foreground: #111928;
  --destructive: #d92d20;
  --destructive-foreground: #ffffff;
  --border: #e5e7eb;
  --border-strong: #888f9c;
  --input: #888f9c;
  --ring: #8f3434;
  --overlay: #00000080;
  --text-subtle: #4b5563;
  --text-disabled: #9ca3af;
  --surface-sunken: #f3f4f6;
  --surface-raised: #ffffff;
  --sidebar: #ffffff;
  --sidebar-foreground: #4b5563;
  --sidebar-primary: #6b1d1d;
  --sidebar-primary-foreground: #ffffff;
  --sidebar-accent: #f7ecec;
  --sidebar-accent-foreground: #521313;
  --sidebar-border: #e5e7eb;
  --sidebar-ring: #8f3434;
  --success: #027a48;
  --success-foreground: #ffffff;
  --success-subtle: #ecfdf3;
  --success-subtle-foreground: #027a48;
  --success-border: #a6f4c5;
  --warning: #f79009;
  --warning-foreground: #111928;
  --warning-subtle: #fffaeb;
  --warning-subtle-foreground: #b54708;
  --warning-border: #fedf89;
  --danger: #d92d20;
  --danger-foreground: #ffffff;
  --danger-subtle: #fef3f2;
  --danger-subtle-foreground: #b42318;
  --danger-border: #fecdca;
  --chart-approved: #027a48;
  --chart-submitted: #6ee7b7;
  --chart-draft: #f79009;
  --chart-overdue: #d92d20;
  --info: #1570ef;
  --info-foreground: #ffffff;
  --info-subtle: #eff8ff;
  --info-subtle-foreground: #175cd3;
  --info-border: #b2ddff;
  --status-draft: #fffaeb;
  --status-draft-foreground: #b54708;
  --status-draft-border: #fedf89;
  --status-submitted: #ecfdf3;
  --status-submitted-foreground: #027a48;
  --status-submitted-border: #a6f4c5;
  --status-in-review: #eff8ff;
  --status-in-review-foreground: #175cd3;
  --status-in-review-border: #b2ddff;
  --status-approved: #027a48;
  --status-approved-foreground: #ffffff;
  --status-approved-border: #a6f4c5;
  --status-returned: #fef3f2;
  --status-returned-foreground: #b42318;
  --status-returned-border: #fecdca;
  --status-overdue: #d92d20;
  --status-overdue-foreground: #ffffff;
  --status-overdue-border: #fecdca;
  --status-not-started: #f3f4f6;
  --status-not-started-foreground: #4b5563;
  --status-not-started-border: #e5e7eb;
  --sync-synced: #027a48;
  --sync-synced-foreground: #ffffff;
  --sync-pending: #f79009;
  --sync-pending-foreground: #111928;
  --sync-error: #d92d20;
  --sync-error-foreground: #ffffff;
  --sync-offline: #4b5563;
  --chart-1: #6b1d1d;
  --chart-2: #15b79e;
  --chart-3: #f79009;
  --chart-4: #2e90fa;
  --chart-5: #ee46bc;
  --chart-6: #fb6514;
  --chart-7: #039855;
  --chart-8: #9ca3af;
  --chart-grid: #e5e7eb;
  --chart-axis-label: #4b5563;
  --shadow-color-soft: #1018280f;
  --shadow-color-strong: #1018281a;
  --tactile-highlight: #ffffff99;
  --tactile-edge: #1018281f;
  --focus-ring: #8f343480;
  --focus-ring-danger: #d92d2066;
  --tactile-highlight-on-primary: #ffffff33;
  --tactile-edge-on-primary: #00000033;
  --primary-text: #6b1d1d;
  --chart-approved: #027a48;
  --chart-submitted: #a6f4c5;
  --chart-draft: #fedf89;
  --chart-overdue: #d92d20;

  --header-height: 72px;
  --content-max: 1440px;
  --drawer-width: 480px;
  --dialog-sm: 400px;
  --dialog-md: 560px;
  --dialog-lg: 720px;
  --field-label-width: 200px;
  --sidebar-width: 280px;
  --sidebar-width-icon: 72px;
  --page-padding: 16px;

  --control-height-sm: 32px;
  --control-height-md: 36px;
  --control-height-lg: 40px;
  --control-padding-x: 12px;
  --table-row-height: 48px;
  --table-cell-padding-x: 16px;
  --card-padding: 24px;
  --stack-gap: 16px;
  --control-textarea-min-height: 76px;

  --opacity-disabled: 0.5;
  --opacity-hover-overlay: 0.04;
  --opacity-pressed-overlay: 0.08;
  --opacity-scrim: 0.5;
  --z-base: 0;
  --z-dropdown: 1000;
  --z-sticky: 1100;
  --z-header: 1200;
  --z-overlay: 1300;
  --z-modal: 1400;
  --z-popover: 1500;
  --z-toast: 1600;
  --z-tooltip: 1700;
  --duration-instant: 80ms;
  --duration-fast: 120ms;
  --duration-base: 160ms;
  --duration-slow: 240ms;
  --duration-deliberate: 400ms;
  --press-scale: 0.98;
  --press-offset-y: 1px;

  --border-width-focus: 3px;
  --icon-stroke: 2;
}

.dark {
  --background: #0b0f19;
  --foreground: #f9fafb;
  --card: #111928;
  --card-foreground: #f9fafb;
  --popover: #111928;
  --popover-foreground: #f9fafb;
  --primary: #8f3434;
  --primary-foreground: #ffffff;
  --primary-hover: #b05656;
  --primary-pressed: #6b1d1d;
  --primary-subtle: #1c0606;
  --secondary: #1f2937;
  --secondary-foreground: #f9fafb;
  --muted: #1f2937;
  --muted-foreground: #9ca3af;
  --accent: #1f2937;
  --accent-foreground: #f9fafb;
  --destructive: #d92d20;
  --destructive-foreground: #ffffff;
  --border: #1f2937;
  --border-strong: #888f9c;
  --input: #888f9c;
  --ring: #b05656;
  --overlay: #000000b3;
  --text-subtle: #d1d5db;
  --text-disabled: #4b5563;
  --surface-sunken: #0b0f19;
  --surface-raised: #1f2937;
  --sidebar: #111928;
  --sidebar-foreground: #d1d5db;
  --sidebar-primary: #8f3434;
  --sidebar-primary-foreground: #ffffff;
  --sidebar-accent: #ffffff14;
  --sidebar-accent-foreground: #ffffff;
  --sidebar-border: #1f2937;
  --sidebar-ring: #b05656;
  --success: #027a48;
  --success-foreground: #ffffff;
  --success-subtle: #054f31;
  --success-subtle-foreground: #6ce9a6;
  --success-border: #05603a;
  --warning: #fdb022;
  --warning-foreground: #0b0f19;
  --warning-subtle: #7a2e0e;
  --warning-subtle-foreground: #fec84b;
  --warning-border: #93370d;
  --danger: #d92d20;
  --danger-foreground: #ffffff;
  --danger-subtle: #7a271a;
  --danger-subtle-foreground: #fda29b;
  --danger-border: #912018;
  --info: #1570ef;
  --info-foreground: #ffffff;
  --info-subtle: #194185;
  --info-subtle-foreground: #84caff;
  --info-border: #1849a9;
  --status-draft: #7a2e0e;
  --status-draft-foreground: #fec84b;
  --status-draft-border: #93370d;
  --status-submitted: #054f31;
  --status-submitted-foreground: #6ce9a6;
  --status-submitted-border: #05603a;
  --status-in-review: #194185;
  --status-in-review-foreground: #84caff;
  --status-in-review-border: #1849a9;
  --status-approved: #027a48;
  --status-approved-foreground: #ffffff;
  --status-approved-border: #05603a;
  --status-returned: #7a271a;
  --status-returned-foreground: #fda29b;
  --status-returned-border: #912018;
  --status-overdue: #d92d20;
  --status-overdue-foreground: #ffffff;
  --status-overdue-border: #912018;
  --status-not-started: #1f2937;
  --status-not-started-foreground: #9ca3af;
  --status-not-started-border: #1f2937;
  --sync-synced: #027a48;
  --sync-synced-foreground: #ffffff;
  --sync-pending: #fdb022;
  --sync-pending-foreground: #0b0f19;
  --sync-error: #d92d20;
  --sync-error-foreground: #ffffff;
  --sync-offline: #9ca3af;
  --chart-1: #b05656;
  --chart-2: #2ed3b7;
  --chart-3: #fdb022;
  --chart-4: #53b1fd;
  --chart-5: #f670c7;
  --chart-6: #fd853a;
  --chart-7: #32d583;
  --chart-8: #9ca3af;
  --chart-grid: #1f2937;
  --chart-axis-label: #9ca3af;
  --shadow-color-soft: #00000066;
  --shadow-color-strong: #00000099;
  --tactile-highlight: #ffffff14;
  --tactile-edge: #00000080;
  --focus-ring: #cd8585;
  --focus-ring-danger: #d92d2066;
  --tactile-highlight-on-primary: #ffffff33;
  --tactile-edge-on-primary: #00000033;
  --primary-text: #cd8585;
  --chart-approved: #32d583;
  --chart-submitted: #027a48;
  --chart-draft: #fdb022;
  --chart-overdue: #f97066;
}

[data-theme="sunlight"] {
  --background: #ffffff;
  --foreground: #000000;
  --card: #ffffff;
  --card-foreground: #000000;
  --popover: #ffffff;
  --popover-foreground: #000000;
  --primary: #521313;
  --primary-foreground: #ffffff;
  --primary-hover: #400f0f;
  --primary-pressed: #2e0a0a;
  --primary-subtle: #efd5d5;
  --secondary: #e5e7eb;
  --secondary-foreground: #000000;
  --muted: #f3f4f6;
  --muted-foreground: #374151;
  --accent: #e5e7eb;
  --accent-foreground: #000000;
  --destructive: #912018;
  --destructive-foreground: #ffffff;
  --border: #6b7280;
  --border-strong: #374151;
  --input: #4b5563;
  --ring: #521313;
  --overlay: #000000b3;
  --text-subtle: #1f2937;
  --text-disabled: #6b7280;
  --surface-sunken: #f3f4f6;
  --surface-raised: #ffffff;
  --sidebar: #ffffff;
  --sidebar-foreground: #111928;
  --sidebar-primary: #521313;
  --sidebar-primary-foreground: #ffffff;
  --sidebar-accent: #efd5d5;
  --sidebar-accent-foreground: #2e0a0a;
  --sidebar-border: #6b7280;
  --sidebar-ring: #521313;
  --success: #05603a;
  --success-foreground: #ffffff;
  --success-subtle: #d1fadf;
  --success-subtle-foreground: #054f31;
  --success-border: #027a48;
  --warning: #dc6803;
  --warning-foreground: #000000;
  --warning-subtle: #fef0c7;
  --warning-subtle-foreground: #7a2e0e;
  --warning-border: #b54708;
  --danger: #912018;
  --danger-foreground: #ffffff;
  --danger-subtle: #fee4e2;
  --danger-subtle-foreground: #7a271a;
  --danger-border: #b42318;
  --info: #1849a9;
  --info-foreground: #ffffff;
  --info-subtle: #d1e9ff;
  --info-subtle-foreground: #194185;
  --info-border: #175cd3;
  --status-draft: #fef0c7;
  --status-draft-foreground: #7a2e0e;
  --status-draft-border: #b54708;
  --status-submitted: #d1fadf;
  --status-submitted-foreground: #054f31;
  --status-submitted-border: #027a48;
  --status-in-review: #d1e9ff;
  --status-in-review-foreground: #194185;
  --status-in-review-border: #175cd3;
  --status-approved: #05603a;
  --status-approved-foreground: #ffffff;
  --status-approved-border: #027a48;
  --status-returned: #fee4e2;
  --status-returned-foreground: #7a271a;
  --status-returned-border: #b42318;
  --status-overdue: #912018;
  --status-overdue-foreground: #ffffff;
  --status-overdue-border: #b42318;
  --status-not-started: #f3f4f6;
  --status-not-started-foreground: #374151;
  --status-not-started-border: #6b7280;
  --sync-synced: #05603a;
  --sync-synced-foreground: #ffffff;
  --sync-pending: #dc6803;
  --sync-pending-foreground: #000000;
  --sync-error: #912018;
  --sync-error-foreground: #ffffff;
  --sync-offline: #374151;
  --chart-1: #6b1d1d;
  --chart-2: #15b79e;
  --chart-3: #f79009;
  --chart-4: #2e90fa;
  --chart-5: #ee46bc;
  --chart-6: #fb6514;
  --chart-7: #039855;
  --chart-8: #9ca3af;
  --chart-grid: #e5e7eb;
  --chart-axis-label: #374151;
  --shadow-color-soft: #1018281a;
  --shadow-color-strong: #10182833;
  --tactile-highlight: #ffffffcc;
  --tactile-edge: #10182833;
  --focus-ring: #52131380;
  --focus-ring-danger: #b4231866;
  --tactile-highlight-on-primary: #ffffff33;
  --tactile-edge-on-primary: #00000033;
  --primary-text: #521313;
  --chart-approved: #05603a;
  --chart-submitted: #039855;
  --chart-draft: #f79009;
  --chart-overdue: #b42318;
}

[data-density="compact"] {
  --control-height-sm: 28px;
  --control-height-md: 32px;
  --control-height-lg: 36px;
  --control-padding-x: 10px;
  --table-row-height: 40px;
  --table-cell-padding-x: 12px;
  --card-padding: 16px;
  --stack-gap: 12px;
  --control-textarea-min-height: 64px;
}

@media (min-width: 768px) {
  :root { --page-padding: 24px; }
}
@media (min-width: 1280px) {
  :root { --page-padding: 32px; }
}

:root {
  --radius-xs: 4px;
  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 10px;
  --radius-xl: 12px;
  --radius-2xl: 16px;
  --radius-3xl: 24px;
  --radius-full: 9999px;
}

:root {
  --font-sans: "Inter", "IBM Plex Sans Arabic", sans-serif;
  --font-mono: "JetBrains Mono", ui-monospace, monospace;
  --font-numeric: "Inter", sans-serif;

  --spacing: 4px;
  --breakpoint-sm: 640px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 1024px;
  --breakpoint-xl: 1280px;
  --breakpoint-2xl: 1536px;

  --ease-standard: cubic-bezier(0.2,0,0,1);
  --ease-enter: cubic-bezier(0,0,0,1);
  --ease-exit: cubic-bezier(0.4,0,1,1);

  --text-display: 30px;
  --text-display--line-height: 38px;
  --text-display--font-weight: 600;
  --text-display--letter-spacing: -0.2px;
  --text-h1: 24px;
  --text-h1--line-height: 32px;
  --text-h1--font-weight: 600;
  --text-h1--letter-spacing: -0.2px;
  --text-h2: 20px;
  --text-h2--line-height: 28px;
  --text-h2--font-weight: 600;
  --text-h2--letter-spacing: -0.2px;
  --text-h3: 18px;
  --text-h3--line-height: 26px;
  --text-h3--font-weight: 600;
  --text-h4: 16px;
  --text-h4--line-height: 24px;
  --text-h4--font-weight: 600;
  --text-body-lg: 16px;
  --text-body-lg--line-height: 24px;
  --text-body-lg--font-weight: 400;
  --text-body: 14px;
  --text-body--line-height: 20px;
  --text-body--font-weight: 400;
  --text-body-sm: 13px;
  --text-body-sm--line-height: 18px;
  --text-body-sm--font-weight: 400;
  --text-caption: 12px;
  --text-caption--line-height: 16px;
  --text-caption--font-weight: 400;
  --text-overline: 11px;
  --text-overline--line-height: 16px;
  --text-overline--font-weight: 600;
  --text-label: 14px;
  --text-label--line-height: 20px;
  --text-label--font-weight: 500;
  --text-label-sm: 12px;
  --text-label-sm--line-height: 16px;
  --text-label-sm--font-weight: 500;
  --text-button: 14px;
  --text-button--line-height: 20px;
  --text-button--font-weight: 600;
  --text-kpi: 24px;
  --text-kpi--line-height: 32px;
  --text-kpi--font-weight: 600;
  --text-kpi-xl: 32px;
  --text-kpi-xl--line-height: 40px;
  --text-kpi-xl--font-weight: 700;
  --text-mono: 13px;
  --text-mono--line-height: 20px;
  --text-mono--font-weight: 400;
}

:lang(ar) {
  --font-sans: "IBM Plex Sans Arabic", "Inter", sans-serif;
  --text-display--line-height: 42px;
  --text-display--letter-spacing: 0;
  --text-h1--line-height: 36px;
  --text-h1--letter-spacing: 0;
  --text-h2--line-height: 32px;
  --text-h2--letter-spacing: 0;
  --text-h3--line-height: 30px;
  --text-h4--line-height: 28px;
  --text-body-lg--line-height: 28px;
  --text-body--line-height: 24px;
  --text-body-sm--line-height: 22px;
  --text-caption--line-height: 20px;
  --text-overline--line-height: 20px;
  --text-label--line-height: 24px;
  --text-label-sm--line-height: 20px;
  --text-button--line-height: 24px;
  --text-kpi--line-height: 36px;
  --text-kpi-xl--line-height: 44px;
  --text-mono--line-height: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/tokens/tokens.css"],"names":[],"mappings":"AAAA;iNACiN;;AAEjN;EACE,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;EACtB,iCAAiC;EACjC,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;EACrC,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;EACzB,iBAAiB;EACjB,4BAA4B;EAC5B,wBAAwB;EACxB,mCAAmC;EACnC,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;EACtB,iCAAiC;EACjC,sBAAsB;EACtB,uBAAuB;EACvB,kCAAkC;EAClC,8BAA8B;EAC9B,2BAA2B;EAC3B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sCAAsC;EACtC,kCAAkC;EAClC,0BAA0B;EAC1B,qCAAqC;EACrC,iCAAiC;EACjC,0BAA0B;EAC1B,qCAAqC;EACrC,iCAAiC;EACjC,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;EAChC,6BAA6B;EAC7B,wCAAwC;EACxC,oCAAoC;EACpC,sBAAsB;EACtB,iCAAiC;EACjC,uBAAuB;EACvB,kCAAkC;EAClC,qBAAqB;EACrB,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;EACvB,8BAA8B;EAC9B,yCAAyC;EACzC,oCAAoC;EACpC,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;;EAExB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;;EAEpB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,oBAAoB;EACpB,iBAAiB;EACjB,mCAAmC;;EAEnC,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;EACnB,qBAAqB;;EAErB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;EACtB,iCAAiC;EACjC,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;EACrC,2BAA2B;EAC3B,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;EACzB,iBAAiB;EACjB,4BAA4B;EAC5B,wBAAwB;EACxB,mCAAmC;EACnC,wBAAwB;EACxB,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;EACtB,iCAAiC;EACjC,sBAAsB;EACtB,uBAAuB;EACvB,kCAAkC;EAClC,8BAA8B;EAC9B,2BAA2B;EAC3B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sCAAsC;EACtC,kCAAkC;EAClC,0BAA0B;EAC1B,qCAAqC;EACrC,iCAAiC;EACjC,0BAA0B;EAC1B,qCAAqC;EACrC,iCAAiC;EACjC,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;EAChC,6BAA6B;EAC7B,wCAAwC;EACxC,oCAAoC;EACpC,sBAAsB;EACtB,iCAAiC;EACjC,uBAAuB;EACvB,kCAAkC;EAClC,qBAAqB;EACrB,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,8BAA8B;EAC9B,yCAAyC;EACzC,oCAAoC;EACpC,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;EACtB,iCAAiC;EACjC,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;EACrC,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;EACzB,iBAAiB;EACjB,4BAA4B;EAC5B,wBAAwB;EACxB,mCAAmC;EACnC,wBAAwB;EACxB,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;EACtB,iCAAiC;EACjC,sBAAsB;EACtB,uBAAuB;EACvB,kCAAkC;EAClC,8BAA8B;EAC9B,2BAA2B;EAC3B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sCAAsC;EACtC,kCAAkC;EAClC,0BAA0B;EAC1B,qCAAqC;EACrC,iCAAiC;EACjC,0BAA0B;EAC1B,qCAAqC;EACrC,iCAAiC;EACjC,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;EAChC,6BAA6B;EAC7B,wCAAwC;EACxC,oCAAoC;EACpC,sBAAsB;EACtB,iCAAiC;EACjC,uBAAuB;EACvB,kCAAkC;EAClC,qBAAqB;EACrB,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;EACvB,8BAA8B;EAC9B,yCAAyC;EACzC,oCAAoC;EACpC,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,oBAAoB;EACpB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,QAAQ,oBAAoB,EAAE;AAChC;AACA;EACE,QAAQ,oBAAoB,EAAE;AAChC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,wDAAwD;EACxD,sDAAsD;EACtD,mCAAmC;;EAEnC,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;;EAExB,wCAAwC;EACxC,mCAAmC;EACnC,oCAAoC;;EAEpC,oBAAoB;EACpB,iCAAiC;EACjC,gCAAgC;EAChC,sCAAsC;EACtC,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;EAC3B,iCAAiC;EACjC,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;EAC3B,iCAAiC;EACjC,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;EAC3B,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;EAC3B,oBAAoB;EACpB,iCAAiC;EACjC,gCAAgC;EAChC,iBAAiB;EACjB,8BAA8B;EAC9B,6BAA6B;EAC7B,oBAAoB;EACpB,iCAAiC;EACjC,gCAAgC;EAChC,oBAAoB;EACpB,iCAAiC;EACjC,gCAAgC;EAChC,qBAAqB;EACrB,kCAAkC;EAClC,iCAAiC;EACjC,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,qBAAqB;EACrB,kCAAkC;EAClC,iCAAiC;EACjC,mBAAmB;EACnB,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,mBAAmB;EACnB,gCAAgC;EAChC,+BAA+B;EAC/B,iBAAiB;EACjB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,wDAAwD;EACxD,iCAAiC;EACjC,iCAAiC;EACjC,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,iCAAiC;EACjC,8BAA8B;EAC9B,iCAAiC;EACjC,iCAAiC;EACjC,kCAAkC;EAClC,+BAA+B;EAC/B,kCAAkC;EAClC,gCAAgC;EAChC,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;AAChC","sourcesContent":["/* JoPath design tokens — generated from Figma \"JoPath · Foundations\" variables (P60), as plain CSS custom properties. Do not edit by hand; re-export instead.\r\n   Imported before index.css: index.css's own :root re-declares --muted/--radius/--radius-sm after this file loads, so the existing OMS look is unchanged. New UI (the app shell) should read tokens from here. */\r\n\r\n:root {\r\n  --radius: 10px;\r\n  --background: #f9fafb;\r\n  --foreground: #111928;\r\n  --card: #ffffff;\r\n  --card-foreground: #111928;\r\n  --popover: #ffffff;\r\n  --popover-foreground: #111928;\r\n  --primary: #6b1d1d;\r\n  --primary-foreground: #ffffff;\r\n  --primary-hover: #521313;\r\n  --primary-pressed: #400f0f;\r\n  --primary-subtle: #f7ecec;\r\n  --secondary: #f3f4f6;\r\n  --secondary-foreground: #111928;\r\n  --muted: #f3f4f6;\r\n  --muted-foreground: #4b5563;\r\n  --accent: #f3f4f6;\r\n  --accent-foreground: #111928;\r\n  --destructive: #d92d20;\r\n  --destructive-foreground: #ffffff;\r\n  --border: #e5e7eb;\r\n  --border-strong: #888f9c;\r\n  --input: #888f9c;\r\n  --ring: #8f3434;\r\n  --overlay: #00000080;\r\n  --text-subtle: #4b5563;\r\n  --text-disabled: #9ca3af;\r\n  --surface-sunken: #f3f4f6;\r\n  --surface-raised: #ffffff;\r\n  --sidebar: #ffffff;\r\n  --sidebar-foreground: #4b5563;\r\n  --sidebar-primary: #6b1d1d;\r\n  --sidebar-primary-foreground: #ffffff;\r\n  --sidebar-accent: #f7ecec;\r\n  --sidebar-accent-foreground: #521313;\r\n  --sidebar-border: #e5e7eb;\r\n  --sidebar-ring: #8f3434;\r\n  --success: #027a48;\r\n  --success-foreground: #ffffff;\r\n  --success-subtle: #ecfdf3;\r\n  --success-subtle-foreground: #027a48;\r\n  --success-border: #a6f4c5;\r\n  --warning: #f79009;\r\n  --warning-foreground: #111928;\r\n  --warning-subtle: #fffaeb;\r\n  --warning-subtle-foreground: #b54708;\r\n  --warning-border: #fedf89;\r\n  --danger: #d92d20;\r\n  --danger-foreground: #ffffff;\r\n  --danger-subtle: #fef3f2;\r\n  --danger-subtle-foreground: #b42318;\r\n  --danger-border: #fecdca;\r\n  --chart-approved: #027a48;\r\n  --chart-submitted: #6ee7b7;\r\n  --chart-draft: #f79009;\r\n  --chart-overdue: #d92d20;\r\n  --info: #1570ef;\r\n  --info-foreground: #ffffff;\r\n  --info-subtle: #eff8ff;\r\n  --info-subtle-foreground: #175cd3;\r\n  --info-border: #b2ddff;\r\n  --status-draft: #fffaeb;\r\n  --status-draft-foreground: #b54708;\r\n  --status-draft-border: #fedf89;\r\n  --status-submitted: #ecfdf3;\r\n  --status-submitted-foreground: #027a48;\r\n  --status-submitted-border: #a6f4c5;\r\n  --status-in-review: #eff8ff;\r\n  --status-in-review-foreground: #175cd3;\r\n  --status-in-review-border: #b2ddff;\r\n  --status-approved: #027a48;\r\n  --status-approved-foreground: #ffffff;\r\n  --status-approved-border: #a6f4c5;\r\n  --status-returned: #fef3f2;\r\n  --status-returned-foreground: #b42318;\r\n  --status-returned-border: #fecdca;\r\n  --status-overdue: #d92d20;\r\n  --status-overdue-foreground: #ffffff;\r\n  --status-overdue-border: #fecdca;\r\n  --status-not-started: #f3f4f6;\r\n  --status-not-started-foreground: #4b5563;\r\n  --status-not-started-border: #e5e7eb;\r\n  --sync-synced: #027a48;\r\n  --sync-synced-foreground: #ffffff;\r\n  --sync-pending: #f79009;\r\n  --sync-pending-foreground: #111928;\r\n  --sync-error: #d92d20;\r\n  --sync-error-foreground: #ffffff;\r\n  --sync-offline: #4b5563;\r\n  --chart-1: #6b1d1d;\r\n  --chart-2: #15b79e;\r\n  --chart-3: #f79009;\r\n  --chart-4: #2e90fa;\r\n  --chart-5: #ee46bc;\r\n  --chart-6: #fb6514;\r\n  --chart-7: #039855;\r\n  --chart-8: #9ca3af;\r\n  --chart-grid: #e5e7eb;\r\n  --chart-axis-label: #4b5563;\r\n  --shadow-color-soft: #1018280f;\r\n  --shadow-color-strong: #1018281a;\r\n  --tactile-highlight: #ffffff99;\r\n  --tactile-edge: #1018281f;\r\n  --focus-ring: #8f343480;\r\n  --focus-ring-danger: #d92d2066;\r\n  --tactile-highlight-on-primary: #ffffff33;\r\n  --tactile-edge-on-primary: #00000033;\r\n  --primary-text: #6b1d1d;\r\n  --chart-approved: #027a48;\r\n  --chart-submitted: #a6f4c5;\r\n  --chart-draft: #fedf89;\r\n  --chart-overdue: #d92d20;\r\n\r\n  --header-height: 72px;\r\n  --content-max: 1440px;\r\n  --drawer-width: 480px;\r\n  --dialog-sm: 400px;\r\n  --dialog-md: 560px;\r\n  --dialog-lg: 720px;\r\n  --field-label-width: 200px;\r\n  --sidebar-width: 280px;\r\n  --sidebar-width-icon: 72px;\r\n  --page-padding: 16px;\r\n\r\n  --control-height-sm: 32px;\r\n  --control-height-md: 36px;\r\n  --control-height-lg: 40px;\r\n  --control-padding-x: 12px;\r\n  --table-row-height: 48px;\r\n  --table-cell-padding-x: 16px;\r\n  --card-padding: 24px;\r\n  --stack-gap: 16px;\r\n  --control-textarea-min-height: 76px;\r\n\r\n  --opacity-disabled: 0.5;\r\n  --opacity-hover-overlay: 0.04;\r\n  --opacity-pressed-overlay: 0.08;\r\n  --opacity-scrim: 0.5;\r\n  --z-base: 0;\r\n  --z-dropdown: 1000;\r\n  --z-sticky: 1100;\r\n  --z-header: 1200;\r\n  --z-overlay: 1300;\r\n  --z-modal: 1400;\r\n  --z-popover: 1500;\r\n  --z-toast: 1600;\r\n  --z-tooltip: 1700;\r\n  --duration-instant: 80ms;\r\n  --duration-fast: 120ms;\r\n  --duration-base: 160ms;\r\n  --duration-slow: 240ms;\r\n  --duration-deliberate: 400ms;\r\n  --press-scale: 0.98;\r\n  --press-offset-y: 1px;\r\n\r\n  --border-width-focus: 3px;\r\n  --icon-stroke: 2;\r\n}\r\n\r\n.dark {\r\n  --background: #0b0f19;\r\n  --foreground: #f9fafb;\r\n  --card: #111928;\r\n  --card-foreground: #f9fafb;\r\n  --popover: #111928;\r\n  --popover-foreground: #f9fafb;\r\n  --primary: #8f3434;\r\n  --primary-foreground: #ffffff;\r\n  --primary-hover: #b05656;\r\n  --primary-pressed: #6b1d1d;\r\n  --primary-subtle: #1c0606;\r\n  --secondary: #1f2937;\r\n  --secondary-foreground: #f9fafb;\r\n  --muted: #1f2937;\r\n  --muted-foreground: #9ca3af;\r\n  --accent: #1f2937;\r\n  --accent-foreground: #f9fafb;\r\n  --destructive: #d92d20;\r\n  --destructive-foreground: #ffffff;\r\n  --border: #1f2937;\r\n  --border-strong: #888f9c;\r\n  --input: #888f9c;\r\n  --ring: #b05656;\r\n  --overlay: #000000b3;\r\n  --text-subtle: #d1d5db;\r\n  --text-disabled: #4b5563;\r\n  --surface-sunken: #0b0f19;\r\n  --surface-raised: #1f2937;\r\n  --sidebar: #111928;\r\n  --sidebar-foreground: #d1d5db;\r\n  --sidebar-primary: #8f3434;\r\n  --sidebar-primary-foreground: #ffffff;\r\n  --sidebar-accent: #ffffff14;\r\n  --sidebar-accent-foreground: #ffffff;\r\n  --sidebar-border: #1f2937;\r\n  --sidebar-ring: #b05656;\r\n  --success: #027a48;\r\n  --success-foreground: #ffffff;\r\n  --success-subtle: #054f31;\r\n  --success-subtle-foreground: #6ce9a6;\r\n  --success-border: #05603a;\r\n  --warning: #fdb022;\r\n  --warning-foreground: #0b0f19;\r\n  --warning-subtle: #7a2e0e;\r\n  --warning-subtle-foreground: #fec84b;\r\n  --warning-border: #93370d;\r\n  --danger: #d92d20;\r\n  --danger-foreground: #ffffff;\r\n  --danger-subtle: #7a271a;\r\n  --danger-subtle-foreground: #fda29b;\r\n  --danger-border: #912018;\r\n  --info: #1570ef;\r\n  --info-foreground: #ffffff;\r\n  --info-subtle: #194185;\r\n  --info-subtle-foreground: #84caff;\r\n  --info-border: #1849a9;\r\n  --status-draft: #7a2e0e;\r\n  --status-draft-foreground: #fec84b;\r\n  --status-draft-border: #93370d;\r\n  --status-submitted: #054f31;\r\n  --status-submitted-foreground: #6ce9a6;\r\n  --status-submitted-border: #05603a;\r\n  --status-in-review: #194185;\r\n  --status-in-review-foreground: #84caff;\r\n  --status-in-review-border: #1849a9;\r\n  --status-approved: #027a48;\r\n  --status-approved-foreground: #ffffff;\r\n  --status-approved-border: #05603a;\r\n  --status-returned: #7a271a;\r\n  --status-returned-foreground: #fda29b;\r\n  --status-returned-border: #912018;\r\n  --status-overdue: #d92d20;\r\n  --status-overdue-foreground: #ffffff;\r\n  --status-overdue-border: #912018;\r\n  --status-not-started: #1f2937;\r\n  --status-not-started-foreground: #9ca3af;\r\n  --status-not-started-border: #1f2937;\r\n  --sync-synced: #027a48;\r\n  --sync-synced-foreground: #ffffff;\r\n  --sync-pending: #fdb022;\r\n  --sync-pending-foreground: #0b0f19;\r\n  --sync-error: #d92d20;\r\n  --sync-error-foreground: #ffffff;\r\n  --sync-offline: #9ca3af;\r\n  --chart-1: #b05656;\r\n  --chart-2: #2ed3b7;\r\n  --chart-3: #fdb022;\r\n  --chart-4: #53b1fd;\r\n  --chart-5: #f670c7;\r\n  --chart-6: #fd853a;\r\n  --chart-7: #32d583;\r\n  --chart-8: #9ca3af;\r\n  --chart-grid: #1f2937;\r\n  --chart-axis-label: #9ca3af;\r\n  --shadow-color-soft: #00000066;\r\n  --shadow-color-strong: #00000099;\r\n  --tactile-highlight: #ffffff14;\r\n  --tactile-edge: #00000080;\r\n  --focus-ring: #cd8585;\r\n  --focus-ring-danger: #d92d2066;\r\n  --tactile-highlight-on-primary: #ffffff33;\r\n  --tactile-edge-on-primary: #00000033;\r\n  --primary-text: #cd8585;\r\n  --chart-approved: #32d583;\r\n  --chart-submitted: #027a48;\r\n  --chart-draft: #fdb022;\r\n  --chart-overdue: #f97066;\r\n}\r\n\r\n[data-theme=\"sunlight\"] {\r\n  --background: #ffffff;\r\n  --foreground: #000000;\r\n  --card: #ffffff;\r\n  --card-foreground: #000000;\r\n  --popover: #ffffff;\r\n  --popover-foreground: #000000;\r\n  --primary: #521313;\r\n  --primary-foreground: #ffffff;\r\n  --primary-hover: #400f0f;\r\n  --primary-pressed: #2e0a0a;\r\n  --primary-subtle: #efd5d5;\r\n  --secondary: #e5e7eb;\r\n  --secondary-foreground: #000000;\r\n  --muted: #f3f4f6;\r\n  --muted-foreground: #374151;\r\n  --accent: #e5e7eb;\r\n  --accent-foreground: #000000;\r\n  --destructive: #912018;\r\n  --destructive-foreground: #ffffff;\r\n  --border: #6b7280;\r\n  --border-strong: #374151;\r\n  --input: #4b5563;\r\n  --ring: #521313;\r\n  --overlay: #000000b3;\r\n  --text-subtle: #1f2937;\r\n  --text-disabled: #6b7280;\r\n  --surface-sunken: #f3f4f6;\r\n  --surface-raised: #ffffff;\r\n  --sidebar: #ffffff;\r\n  --sidebar-foreground: #111928;\r\n  --sidebar-primary: #521313;\r\n  --sidebar-primary-foreground: #ffffff;\r\n  --sidebar-accent: #efd5d5;\r\n  --sidebar-accent-foreground: #2e0a0a;\r\n  --sidebar-border: #6b7280;\r\n  --sidebar-ring: #521313;\r\n  --success: #05603a;\r\n  --success-foreground: #ffffff;\r\n  --success-subtle: #d1fadf;\r\n  --success-subtle-foreground: #054f31;\r\n  --success-border: #027a48;\r\n  --warning: #dc6803;\r\n  --warning-foreground: #000000;\r\n  --warning-subtle: #fef0c7;\r\n  --warning-subtle-foreground: #7a2e0e;\r\n  --warning-border: #b54708;\r\n  --danger: #912018;\r\n  --danger-foreground: #ffffff;\r\n  --danger-subtle: #fee4e2;\r\n  --danger-subtle-foreground: #7a271a;\r\n  --danger-border: #b42318;\r\n  --info: #1849a9;\r\n  --info-foreground: #ffffff;\r\n  --info-subtle: #d1e9ff;\r\n  --info-subtle-foreground: #194185;\r\n  --info-border: #175cd3;\r\n  --status-draft: #fef0c7;\r\n  --status-draft-foreground: #7a2e0e;\r\n  --status-draft-border: #b54708;\r\n  --status-submitted: #d1fadf;\r\n  --status-submitted-foreground: #054f31;\r\n  --status-submitted-border: #027a48;\r\n  --status-in-review: #d1e9ff;\r\n  --status-in-review-foreground: #194185;\r\n  --status-in-review-border: #175cd3;\r\n  --status-approved: #05603a;\r\n  --status-approved-foreground: #ffffff;\r\n  --status-approved-border: #027a48;\r\n  --status-returned: #fee4e2;\r\n  --status-returned-foreground: #7a271a;\r\n  --status-returned-border: #b42318;\r\n  --status-overdue: #912018;\r\n  --status-overdue-foreground: #ffffff;\r\n  --status-overdue-border: #b42318;\r\n  --status-not-started: #f3f4f6;\r\n  --status-not-started-foreground: #374151;\r\n  --status-not-started-border: #6b7280;\r\n  --sync-synced: #05603a;\r\n  --sync-synced-foreground: #ffffff;\r\n  --sync-pending: #dc6803;\r\n  --sync-pending-foreground: #000000;\r\n  --sync-error: #912018;\r\n  --sync-error-foreground: #ffffff;\r\n  --sync-offline: #374151;\r\n  --chart-1: #6b1d1d;\r\n  --chart-2: #15b79e;\r\n  --chart-3: #f79009;\r\n  --chart-4: #2e90fa;\r\n  --chart-5: #ee46bc;\r\n  --chart-6: #fb6514;\r\n  --chart-7: #039855;\r\n  --chart-8: #9ca3af;\r\n  --chart-grid: #e5e7eb;\r\n  --chart-axis-label: #374151;\r\n  --shadow-color-soft: #1018281a;\r\n  --shadow-color-strong: #10182833;\r\n  --tactile-highlight: #ffffffcc;\r\n  --tactile-edge: #10182833;\r\n  --focus-ring: #52131380;\r\n  --focus-ring-danger: #b4231866;\r\n  --tactile-highlight-on-primary: #ffffff33;\r\n  --tactile-edge-on-primary: #00000033;\r\n  --primary-text: #521313;\r\n  --chart-approved: #05603a;\r\n  --chart-submitted: #039855;\r\n  --chart-draft: #f79009;\r\n  --chart-overdue: #b42318;\r\n}\r\n\r\n[data-density=\"compact\"] {\r\n  --control-height-sm: 28px;\r\n  --control-height-md: 32px;\r\n  --control-height-lg: 36px;\r\n  --control-padding-x: 10px;\r\n  --table-row-height: 40px;\r\n  --table-cell-padding-x: 12px;\r\n  --card-padding: 16px;\r\n  --stack-gap: 12px;\r\n  --control-textarea-min-height: 64px;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  :root { --page-padding: 24px; }\r\n}\r\n@media (min-width: 1280px) {\r\n  :root { --page-padding: 32px; }\r\n}\r\n\r\n:root {\r\n  --radius-xs: 4px;\r\n  --radius-sm: 6px;\r\n  --radius-md: 8px;\r\n  --radius-lg: 10px;\r\n  --radius-xl: 12px;\r\n  --radius-2xl: 16px;\r\n  --radius-3xl: 24px;\r\n  --radius-full: 9999px;\r\n}\r\n\r\n:root {\r\n  --font-sans: \"Inter\", \"IBM Plex Sans Arabic\", sans-serif;\r\n  --font-mono: \"JetBrains Mono\", ui-monospace, monospace;\r\n  --font-numeric: \"Inter\", sans-serif;\r\n\r\n  --spacing: 4px;\r\n  --breakpoint-sm: 640px;\r\n  --breakpoint-md: 768px;\r\n  --breakpoint-lg: 1024px;\r\n  --breakpoint-xl: 1280px;\r\n  --breakpoint-2xl: 1536px;\r\n\r\n  --ease-standard: cubic-bezier(0.2,0,0,1);\r\n  --ease-enter: cubic-bezier(0,0,0,1);\r\n  --ease-exit: cubic-bezier(0.4,0,1,1);\r\n\r\n  --text-display: 30px;\r\n  --text-display--line-height: 38px;\r\n  --text-display--font-weight: 600;\r\n  --text-display--letter-spacing: -0.2px;\r\n  --text-h1: 24px;\r\n  --text-h1--line-height: 32px;\r\n  --text-h1--font-weight: 600;\r\n  --text-h1--letter-spacing: -0.2px;\r\n  --text-h2: 20px;\r\n  --text-h2--line-height: 28px;\r\n  --text-h2--font-weight: 600;\r\n  --text-h2--letter-spacing: -0.2px;\r\n  --text-h3: 18px;\r\n  --text-h3--line-height: 26px;\r\n  --text-h3--font-weight: 600;\r\n  --text-h4: 16px;\r\n  --text-h4--line-height: 24px;\r\n  --text-h4--font-weight: 600;\r\n  --text-body-lg: 16px;\r\n  --text-body-lg--line-height: 24px;\r\n  --text-body-lg--font-weight: 400;\r\n  --text-body: 14px;\r\n  --text-body--line-height: 20px;\r\n  --text-body--font-weight: 400;\r\n  --text-body-sm: 13px;\r\n  --text-body-sm--line-height: 18px;\r\n  --text-body-sm--font-weight: 400;\r\n  --text-caption: 12px;\r\n  --text-caption--line-height: 16px;\r\n  --text-caption--font-weight: 400;\r\n  --text-overline: 11px;\r\n  --text-overline--line-height: 16px;\r\n  --text-overline--font-weight: 600;\r\n  --text-label: 14px;\r\n  --text-label--line-height: 20px;\r\n  --text-label--font-weight: 500;\r\n  --text-label-sm: 12px;\r\n  --text-label-sm--line-height: 16px;\r\n  --text-label-sm--font-weight: 500;\r\n  --text-button: 14px;\r\n  --text-button--line-height: 20px;\r\n  --text-button--font-weight: 600;\r\n  --text-kpi: 24px;\r\n  --text-kpi--line-height: 32px;\r\n  --text-kpi--font-weight: 600;\r\n  --text-kpi-xl: 32px;\r\n  --text-kpi-xl--line-height: 40px;\r\n  --text-kpi-xl--font-weight: 700;\r\n  --text-mono: 13px;\r\n  --text-mono--line-height: 20px;\r\n  --text-mono--font-weight: 400;\r\n}\r\n\r\n:lang(ar) {\r\n  --font-sans: \"IBM Plex Sans Arabic\", \"Inter\", sans-serif;\r\n  --text-display--line-height: 42px;\r\n  --text-display--letter-spacing: 0;\r\n  --text-h1--line-height: 36px;\r\n  --text-h1--letter-spacing: 0;\r\n  --text-h2--line-height: 32px;\r\n  --text-h2--letter-spacing: 0;\r\n  --text-h3--line-height: 30px;\r\n  --text-h4--line-height: 28px;\r\n  --text-body-lg--line-height: 28px;\r\n  --text-body--line-height: 24px;\r\n  --text-body-sm--line-height: 22px;\r\n  --text-caption--line-height: 20px;\r\n  --text-overline--line-height: 20px;\r\n  --text-label--line-height: 24px;\r\n  --text-label-sm--line-height: 20px;\r\n  --text-button--line-height: 24px;\r\n  --text-kpi--line-height: 36px;\r\n  --text-kpi-xl--line-height: 44px;\r\n  --text-mono--line-height: 24px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
